/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "The Friendship Hub",
      "Find New Friends With Bumble For Friends App | Bumble",
      "Download on the App Store",
      "Get it on Google Play",
      "A dedicated space to make new friends",
      "Discover people near you who are here for genuine connections.",
      "Find friends for all stages of life",
      "New to town? Need a fresh start? Your new crew is waiting for you!",
      "A safe space for everyone",
      "Welcome to a kind part of the internet, where you can be you.",
      "Download the app",
      "Meet IRL with people who share your interests!",
      "Get to know a new group of people with Plans on Bumble For Friends",
      "You’ve been invited to join Plans",
      "Plans is a new feature on Bumble For Friends where you can create and join group meetups with new friends near you",
      "Manage Cookies",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "ditë",
                  "ditët",
                  "ditëve",
                  "ditëve",
                  "ditëve"
            ],
            "singular": [
                  "ditë",
                  "ditën",
                  "ditës",
                  "ditës",
                  "ditës"
            ]
      },
      "hour": {
            "plural": [
                  "orë",
                  "orët",
                  "orëve",
                  "orëve",
                  "orëve"
            ],
            "singular": [
                  "orë",
                  "orën",
                  "orës",
                  "ore",
                  "ore"
            ]
      },
      "minute": {
            "plural": [
                  "minuta",
                  "minutat",
                  "minutave",
                  "minutave",
                  "minutave"
            ],
            "singular": [
                  "minutë",
                  "minutin",
                  "minutit",
                  "minutit",
                  "minutit"
            ]
      },
      "month": {
            "plural": [
                  "muaj",
                  "muajt",
                  "muajve",
                  "muajve",
                  "muajve"
            ],
            "singular": [
                  "muaj",
                  "muajin",
                  "muajit",
                  "muajit",
                  "muajit"
            ]
      },
      "second": {
            "plural": [
                  "sekonda",
                  "sekondat",
                  "sekondave",
                  "sekondave",
                  "sekondave"
            ],
            "singular": [
                  "sekondë",
                  "sekondin",
                  "sekondit",
                  "sekondit",
                  "sekondit"
            ]
      },
      "year": {
            "plural": [
                  "vite",
                  "vitet",
                  "viteve",
                  "viteve",
                  "viteve"
            ],
            "singular": [
                  "vit",
                  "vitin",
                  "vitit",
                  "vitit",
                  "vitit"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
